// withSentrySpan.js
'use strict';
import React from 'react';
import PropTypes from 'prop-types';

import { useSentryStartSpan, useSentryEndSpan } from '../hook/useSentrySpan.js';

export const withSentryStartSpan = Component => {
  const WrappedComponent = props => {
    const { shouldEnableSentrySpan } = props;
    useSentryStartSpan({
      shouldEnable: shouldEnableSentrySpan,
    });
    return <Component {...props} />;
  };

  WrappedComponent.displayName = `withSentryStartSpan(${Component.displayName || Component.name || 'unknown'})`;

  WrappedComponent.propTypes = {
    shouldEnableSentrySpan: PropTypes.bool,
  };

  return WrappedComponent;
};

export const withSentryEndSpan = Component => {
  const WrappedComponent = props => {
    const { endSpan } = useSentryEndSpan();
    return <Component {...props} endSpan={endSpan} />;
  };

  WrappedComponent.displayName = `withSentryEndSpan(${Component.displayName || Component.name || 'unknown'})`;

  return WrappedComponent;
};
